import { useSelector } from 'react-redux';
import {
  useQuery,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
  gql,
} from '@apollo/client';
import { RootState } from '../../../../store/store';

const GQL_QUE = gql`
  query GetAllUsersCount {
    getAllUsersCount
  }
`;

interface GetAllUsersCountHook {
  data: number | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllUsersCount: number;
    }>
  >;
}

interface GetAllUsersCountMutationData {
  getAllUsersCount: number;
}

export function useGetAllUsersCount(): GetAllUsersCountHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } =
    useQuery<GetAllUsersCountMutationData>(GQL_QUE, {
      context: {
        headers: {
          cookie: `jwt=${jwt}`,
          authorization: jwt ? `Bearer ${jwt}` : '',
        },
      },
    });

  return {
    data: data?.getAllUsersCount,
    loading,
    error,
    refetch,
  };
}
